import React, { memo, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
import {
  ListItem,
  ListItemText,
  Typography,
  Grid,
  Box,
  Checkbox,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import componentStyles from "../assets/styles/components/task_list";
import TextileView from "./atoms/textile_view";

const useStyles = makeStyles(componentStyles);

const TaskListItem = (props) => {
  const { issue, updateTask, taskListStatus } = props;
  const [open, setOpen] = useState(false);
  const [taskStatus, setTaskStatus] = useState(false);
  const classes = useStyles();

  const isClosed = (statusId) => {
    let res;
    switch (statusId.toString()) {
      case taskListStatus.closed?.id:
        res = true;
        break;
      default:
        res = false;
    }
    return res;
  };

  const handleClickListItem = () => {
    setOpen(!open);
  };
  const handleChangeStatus = (e) => {
    const checked = e.target.checked;
    setTaskStatus(checked);
    // updateの処理
    const issueStatus = checked
      ? taskListStatus.closed?.id
      : taskListStatus.progress?.id;
    const statusName =
      issueStatus === taskListStatus.closed?.id
        ? taskListStatus.closed?.name
        : taskListStatus.progress?.name;

    updateTask(issue.id, issueStatus, statusName);
  };

  useEffect(() => {
    setTaskStatus(isClosed(issue.status.id));
  }, [props]);

  return (
    <>
      <ListItem
        className={classes.taskListItem}
        alignItems="flex-start"
        key={issue.id}
      >
        <Grid item>
          <Checkbox
            label
            checked={taskStatus}
            color="secondary"
            icon={<RadioButtonUncheckedIcon color="primary" />}
            checkedIcon={<RadioButtonCheckedIcon color="primary" />}
            onChange={(e) => handleChangeStatus(e)}
          />
        </Grid>

        <Grid item>
          <ListItemText
            onClick={handleClickListItem}
            primary={
              <>
                <Typography className={classes.taskTitle}>
                  {issue.subject} [詳細]
                </Typography>
              </>
            }
          />
        </Grid>
      </ListItem>
      <TaskDetail issue={issue} open={open} />
    </>
  );
};

const TaskDetail = (props) => {
  const { issue, open } = props;
  const { description = "", due_date = "", status } = issue;
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const handleClick = () => {
    history.push({
      pathname: "/issue/" + issue.id,
    });
  };
  return (
    <Box style={open ? { display: "block" } : { display: "none" }}>
      <Box className={classes.taskDescWrap}>
        {description ? (
          <Box className={classes.taskDesc}>
            <TextileView text={description} />
          </Box>
        ) : null}
        <Box className={classes.taskParams}>
          <Box className={classes.taskParam}>
            {t("field_status")}:{" "}
            <Box className={classes.taskParamValue}>{status.name}</Box>
          </Box>
          <Box className={classes.taskParam}>
            {t("field_due_date")}:{" "}
            <Box className={classes.taskParamValue}>{due_date}</Box>
          </Box>
        </Box>
      </Box>

      <Grid
        container
        direction="row"
        alignItems="flex-end"
        className={classes.taskActions}
      >
        <Grid item>
          <Button onClick={handleClick}>詳細</Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TaskListItem;
